export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-input-number/node_modules/rmc-feedback/es/index.js
// module id = 436
// module chunks = 0